/**
 * This class is a collection of static utility methods.
 */
export default class Util {
    /**
     * Unused constructor.
     * @constructor
     */
    constructor() {
    }

    /**
     * Checks if the given object is defined and not null.
     * @param {Object} object instance to check.
     * @returns {boolean} true, if the object is defined and not null.
     */
    static isSet(object) {
        return (typeof object !== 'undefined' && object !== null);
    }

    /**
     * Checks if the given string is not set or empty.
     * @param {string} string instance to check.
     * @returns {boolean} true, if the string is not set or empty.
     */
    static isEmpty(string) {
        return (!Util.isSet(string) || string === '' || string.length <= 0);
    }

    /**
     * Checks if the given position is a google.maps.LatLng object or literal.
     * @param {Object} position position-object to check.
     * @returns {boolean} true, if the given position is a google.maps.LatLng object or literal.
     */
    static isLatLng(position) {
        return (Util.isSet(position) &&
            (position instanceof google.maps.LatLng || (position.hasOwnProperty('lat') &&
                position.hasOwnProperty('lng'))));
    }

    /**
     * Escapes the given html.
     * @param {string} html the non escaped html
     * @returns {string} escaped html
     */
    static escapeHtml(html) {
        return String(html)
            .replace(/&/g, '&amp;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
    }

    /**
     * Logs warning messages.
     * @param {string} message message-text to log.
     * @returns {null} null
     */
    static warn(message) {
        if (typeof console === 'object' && 'warn' in console) {
            console.warn(message);
        }
    }

    /**
     * Logs debug messages.
     * @param {string} message message-text to log
     * @returns {null} null
     */
    static debug(message) {
        if (typeof console === 'object' && 'debug' in console) {
            console.debug(message);
        }
    }
}